import { render, staticRenderFns } from "./AddVehicle.vue?vue&type=template&id=bed07c46&scoped=true&"
import script from "./AddVehicle.vue?vue&type=script&lang=js&"
export * from "./AddVehicle.vue?vue&type=script&lang=js&"
import style0 from "./AddVehicle.vue?vue&type=style&index=0&id=bed07c46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed07c46",
  null
  
)

export default component.exports